// features/title/titleSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  value: 'Title',
  viewValue: { name: 'Title', type: '' },
};

export const titleSlice = createSlice({
  name: 'title',
  initialState: INITIAL_STATE,
  reducers: {
    updateTitle: (state, action) => {
      state.value = action.payload;
    },
    updateViewTitle: (state, action) => {
      state.viewValue = action.payload;
    },
    extraReducers: (builder) => {
      builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
    },
  },
});

export const { updateTitle, updateViewTitle } = titleSlice.actions;
export default titleSlice.reducer;
